export default {
    Commitment: {
        title: "評分承諾書",
        desc: "請在下方灰色區域中進行簽名",
        reset: "重簽",
        confirm: "確定",
    },
    Interviewer: {
        signIn: "考官簽到",
        photoSignIn: "拍照簽到",
        complete: "完成簽到",
        rePhoto: "重新拍照",
        capture: "拍照",
        cancel: "取消",
        confirmUpload: "確認簽到",
    },
    ResultTable: {
        average: "平均分",
        max: "最高分",
        min: "最低分",
        sequence: "序號",
        name: "姓名",
        gender: "性別",
        score: "得分",
        interviewing: "進行中",
    },
    ScoreTab: {
        score: "分",
        half: "半分",
        all: "滿分",
        already: "已評",
        comment: "評語",
    },
    StuViewer: {
        signIn: "候選人簽到",
        photoSignIn: "拍照簽到",
        upload: "上傳文件",
        success: "身份核驗通過。",
        fail: "身份核驗未通過！",
        confirm: "確定",
        complete: "完成簽到",
        rePhoto: "重新拍照",
    },
};
